import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, Team, Features, Products, Partners, Banner, Menu } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <Menu/> {/* Menu Section */}
      <Banner /> {/* Banner Section */}
      <Products /> {/* Featured Products */}
      <Team /> {/* Team section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;